export default class CourierManagementColumnModel {
    static CourierManagementColumn = [
      {
        title: 'Delivery method',
        align: 'left',
        field: 'courierName'
      }
    ]
}
